/* ═══ AS OPÇÕES → A VARIANTE — um motor só, duas telas [2026-08-21] ═════════
   Serve o modal do espiar e a página de produto. Antes esta lógica morava
   dentro do `ettore-espiar.js`, e a página de produto simplesmente NÃO TINHA
   seletor — medido em 21/08: o único `name="id"` da página era um hidden com a
   primeira variante, e como os pendentes cobram por tamanho de fio (1m 289 ·
   2m 309 · 3m 319), a loja vendia sempre o mais barato sem oferecer o resto.

   🔑 O MOTOR NÃO SABE DESENHAR NADA. Ele acha a variante e escreve nos ganchos
     `data-eop-*` que a tela declarou. Quem tem `[data-eop-preco]` ganha preço;
     quem não tem, não ganha — e as duas telas continuam com o desenho delas.
     Foi assim que evitei um terceiro lugar guardando a regra de preço.

   🪤 O CASAMENTO É POSIÇÃO A POSIÇÃO, nunca por texto junto. Juntar os valores
     numa string ("Marrom / Fio preto") quebraria em qualquer peça cujo valor
     tenha o separador dentro dele — e "Combo 3 cores" já mostra que nome com
     espaço e número é normal neste catálogo.
*/
(function () {
  'use strict';

  function dinheiroNumero(txt) {
    /* "R$ 1.117,00" → 1117.00. Usado só para comparar preços entre si; o que
       aparece na tela é sempre a string que o Liquid já formatou. */
    return parseFloat(String(txt).replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
  }

  function liga(escopo) {
    if (!escopo) return;
    var caixaJson = escopo.querySelector('[data-eop-variantes]');
    var grade = escopo.querySelector('[data-opcoes]');
    if (!caixaJson || !grade) return;
    if (grade.dataset.eopLigado) return;   /* o modal reusa o mesmo corpo em cache */
    grade.dataset.eopLigado = '1';

    var variantes;
    try { variantes = JSON.parse(caixaJson.textContent); } catch (e) { return; }

    function escolhidas() {
      var fora = [];
      escopo.querySelectorAll('.eop').forEach(function (bloco) {
        var on = bloco.querySelector('.eop-bt.on');
        fora.push(on ? on.getAttribute('data-val') : null);
      });
      return fora;
    }

    function casa(alvo) {
      for (var i = 0; i < variantes.length; i++) {
        var ok = true;
        for (var j = 0; j < alvo.length; j++) {
          if (alvo[j] !== null && variantes[i].op[j] !== alvo[j]) { ok = false; break; }
        }
        if (ok) return variantes[i];
      }
      return null;
    }

    function marca(bloco, val) {
      bloco.querySelectorAll('.eop-bt').forEach(function (o) {
        var on = (o.getAttribute('data-val') || '') === val;
        o.classList.toggle('on', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var rot = bloco.querySelector('[data-eop-val]');
      if (rot) rot.textContent = String(val).trim();
    }

    function achaVariante(blocoClicado) {
      var alvo = escolhidas();
      var v = casa(alvo);
      if (v || !blocoClicado) return v;

      /* 🪤 [2026-09-12] A COMBINAÇÃO NÃO EXISTE — e antes disto a tela FICAVA
           PRESA na variante anterior, sem aviso: botão novo marcado, preço, id e
           botão de compra ainda da escolha de antes. Quem clicasse "3m" numa cor
           que só vem em 1m levava a cor de antes para o carrinho.
         🔑 O padrão do Dawn: a opção que a pessoa acabou de escolher VALE, e os
           outros grupos se reajustam para a primeira variante que a tem. A tela
           passa a mostrar exatamente o que vai para o carrinho. */
      var blocos = Array.prototype.slice.call(escopo.querySelectorAll('.eop'));
      var pos = blocos.indexOf(blocoClicado);
      if (pos < 0) return null;
      var so = alvo.map(function (x, j) { return j === pos ? x : null; });
      v = casa(so);
      if (!v) return null;
      blocos.forEach(function (bloco, j) { if (j !== pos) marca(bloco, v.op[j]); });
      return v;
    }

    function escreve(sel, texto) {
      var el = escopo.querySelector(sel);
      if (el) el.textContent = texto;
      return el;
    }

    function aplica(blocoClicado) {
      /* o rótulo "Cor: Marrom" acompanha a escolha, em toda opção */
      escopo.querySelectorAll('.eop').forEach(function (bloco) {
        var on = bloco.querySelector('.eop-bt.on');
        var rot = bloco.querySelector('[data-eop-val]');
        if (on && rot) rot.textContent = (on.getAttribute('data-val') || '').trim();
      });

      var v = achaVariante(blocoClicado);
      if (!v) return;

      /* ── o id da variante: é ele que decide o que entra no carrinho ───────
         🪤 QUEM ESTÁ COM UM COMBO ESCOLHIDO NÃO PODE PERDER O COMBO AO TROCAR
           A COR. Medido na Luminária Quioto, que é o único caso do catálogo com
           variante E conjuntos ao mesmo tempo: a primeira versão escrevia o id
           da peça avulsa aqui, sem olhar o conjunto ativo — quem escolhesse o
           combo e depois mudasse a base levaria a peça sozinha para o carrinho,
           pagando menos e recebendo menos do que pediu.
           A cor continua valendo para a peça avulsa (o kit dela é atualizado
           logo abaixo); ela só não sequestra mais o formulário. */
      var kitAtivo = escopo.querySelector('[data-kits] .kit.on');
      var kitDaPeca = escopo.querySelector('[data-eop-kit]');
      var podeEscrever = !kitAtivo || !kitDaPeca || kitAtivo === kitDaPeca;
      /* fora do `if`: a pílula "Só esta peça" precisa deste valor mesmo com o combo marcado */
      var temDe = v.temDe && v.temDe > 0 && dinheiroNumero(v.de) > dinheiroNumero(v.preco);
      if (podeEscrever) {
        escopo.querySelectorAll('[data-eop-id]').forEach(function (el) { el.value = v.id; });
      }

      /* 🔴 [2026-09-12] OS SEIS VALORES DA TELA SEGUEM A MESMA TRAVA DO ID.
           `podeEscrever` protegia só o id: com um combo marcado, trocar a cor
           reescrevia preço, Pix, parcela, cashback, riscado e −X% com os da
           PEÇA — tela dizendo R$ 319 e carrinho recebendo o combo de R$ 509
           (Quioto e os pendentes sem data-kit-mapa). Quem pinta a tela do
           combo é o clique no kit (ettore-produto-js); aqui só se escreve
           quando a peça avulsa é o que está marcado. */
      if (podeEscrever) {
        escreve('[data-eop-preco]', v.preco);
        escreve('[data-eop-pix]', v.pix);
        escreve('[data-eop-parc]', v.parc);
        escreve('[data-eop-volta]', v.volta);

        /* 🪤 O RISCADO E O "−X%" SOMEM QUANDO ESTA VARIANTE NÃO TEM PROMOÇÃO.
           Sem isto, trocar para uma variante sem desconto deixaria na tela o
           riscado da anterior, afirmando um desconto que não existe. */
        var de = escopo.querySelector('[data-eop-de]');
        if (de) { de.textContent = v.de; de.hidden = !temDe; }
        var off = escopo.querySelector('[data-eop-off]');
        if (off) { off.textContent = '−' + v.off + '%'; off.hidden = !temDe || !v.off; }
      }

      /* os botões de compra: indisponível não some, fica dizendo por quê.
         🪤 O `data-variante` TAMBÉM É REESCRITO AQUI. No modal do espiar não
           existe formulário — quem leva a peça para o carrinho é o gancho
           `.pc-add[data-variante]` que o ettore-gaveta.js escuta no documento.
           Atualizar só o hidden deixaria o modal adicionando a cor errada. */
      escopo.querySelectorAll('[data-eop-add]').forEach(function (bt) {
        bt.disabled = !v.disp;
        if (bt.hasAttribute('data-variante')) bt.setAttribute('data-variante', v.id);
        /* o rótulo de disponível é o que o Liquid já escreveu — guardado na
           primeira passagem para poder VOLTAR depois de um "Esgotada". Ler o
           texto atual toda vez faria "Esgotada" virar o rótulo permanente. */
        var alvo = bt.querySelector('[data-eop-rotulo]') || bt;
        if (!bt.dataset.eopRotuloOk) {
          bt.dataset.eopRotuloOk = alvo.textContent.trim();
        }
        var esgotado = bt.getAttribute('data-eop-esgotado');
        if (esgotado) alvo.textContent = v.disp ? bt.dataset.eopRotuloOk : esgotado;
      });

      /* ⚠️ O KIT "SÓ ESTA PEÇA" CARREGA A VARIANTE, e o cálculo de frete lê o
         `data-preco` dele (ettore-frete.js). Trocar a cor sem atualizar os dois
         deixaria o carrinho e a simulação de frete falando de outra variante. */
      if (kitDaPeca) {
        kitDaPeca.setAttribute('data-variante', v.id);
        kitDaPeca.setAttribute('data-preco', v.preco);
        /* [2026-09-12] Pix, parcela e cashback vão junto: o clique em "Só esta
           peça" copia os data-* do kit para a tela, e sem isto ele copiava os
           da variante que o Liquid escreveu, não os da cor escolhida. */
        kitDaPeca.setAttribute('data-pix', v.pix);
        kitDaPeca.setAttribute('data-parc', v.parc);
        kitDaPeca.setAttribute('data-volta', v.volta);
        /* [2026-09-21] O RISCADO TAMBÉM VAI — revisão adversarial do Codex. Sem isto, ao voltar do combo
           para "Só esta peça" o ettore-produto.js restaurava o riscado e o "−X%" GUARDADOS NA CARGA (os da
           cor inicial), não os da cor escolhida: uma cor sem promoção voltava a anunciar desconto. Vazio =
           esta cor não tem riscado (o outro lado lê `'de' in dataset`, não o valor). */
        kitDaPeca.setAttribute('data-de', temDe ? v.de : '');
        var vb = kitDaPeca.querySelector('.v b');
        if (vb) vb.textContent = v.preco;
      }

      /* quem quiser mais (a barra de compra, o frete) escuta daqui */
      escopo.dispatchEvent(new CustomEvent('ettore:variante', {
        bubbles: true, detail: v
      }));
    }

    grade.addEventListener('click', function (e) {
      var bt = e.target.closest('.eop-bt');
      if (!bt || !grade.contains(bt)) return;
      var bloco = bt.closest('.eop');
      bloco.querySelectorAll('.eop-bt').forEach(function (o) {
        o.classList.remove('on');
        o.setAttribute('aria-pressed', 'false');
      });
      bt.classList.add('on');
      bt.setAttribute('aria-pressed', 'true');
      aplica(bloco);
    });

    aplica();
  }

  window.ettoreOpcoes = { liga: liga };

  /* a página de produto marca o escopo no HTML e não precisa de mais nada; o
     modal chama `liga()` na mão, porque o corpo dele nasce depois */
  function acorda() {
    document.querySelectorAll('[data-eop-escopo]').forEach(liga);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', acorda);
  } else {
    acorda();
  }
})();
